module.exports = __webpack_public_path__ + "img/ia-04-7.3912b4a8.png";